/*
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-05 17:25:44
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-15 13:48:40
 * @FilePath: /chaoyongtuan/src/views/shopManage/shopLibrary/addMaterial/components/good/columns.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
function getColumns(that){
    let arr = [
        {
            label: '商品信息',
            type: () => import('./tableCells/materialInfoCell.vue'),
            minWidth: '350',
            isShow: true,
            commissionShow: that.$auth.hasPermi('system:goods:commissionRate')
        },
        {
          label: '佣金率',
          type: () => import('./tableCells/commissionRateCell.vue'),
          minWidth: '200',
          isShow: true,
          commissionShow: that.$auth.hasPermi('system:goods:commissionRate')
        },
        {
            key:'serviceRate',
            label: '服务费',
            type: () => import('./tableCells/serviceChargeCell.vue'),
            width: '120',
            isShow: true,
            commissionShow: that.$auth.hasPermi('system:goods:commissionRate')
        },
        {
            key:'productTypeName',
            label: '商品类型',
            type: () => import('./tableCells/goodsTypeCell.vue'),
            width: '120',
            isShow: true,
            commissionShow: that.$auth.hasPermi('system:goods:commissionRate')
        },
        {
            label: '推广状态',
            type: () => import('./tableCells/promotionStatus.vue'),
            width: '120',
            isShow: true,
            commissionShow: that.$auth.hasPermi('system:goods:commissionRate')
        },
        {
            label: '推广时间',
            type: () => import('./tableCells/promotionTime.vue'),
            width: '200',
            isShow: true,
            commissionShow: that.$auth.hasPermi('system:goods:commissionRate')
        },
        {
            label: '店铺',
            type: () => import('./tableCells/storeCell.vue'),
            minWidth: '120',
            isShow: true,
        },
        {
            label:"操作",
            type: () => import('./tableCells/opeationCell.vue'),
            width: '120',
            isShow:  that.isBatch,
        }
    ]
    return arr.filter(item => item.isShow);
}
export default getColumns;